// ЛИГ.1.x: клиентский справочник лиг.
// Используется для прогресса до следующей лиги (Profile pbar, PvpScreen).
//
// Сервер хранит лигу в РУ-имени (players.league). Маппер на EN — в
// trLeague() из serverStrings.ts.

export interface ClientLeague {
  name: string;          // RU-имя, как в БД
  winsToPromote: number | null; // null для Высшей
  next: string | null;   // имя следующей лиги
}

// Должно совпадать с server/src/lib/leagues.ts LEAGUES.
export const LEAGUES_CLIENT: ClientLeague[] = [
  { name: 'Трущобы',       winsToPromote: 3,    next: 'Стритраннеры' },
  { name: 'Стритраннеры',  winsToPromote: 3,    next: 'Нетраннеры' },
  { name: 'Нетраннеры',    winsToPromote: 5,    next: 'Фиксеры' },
  { name: 'Фиксеры',       winsToPromote: 5,    next: 'Оперативники' },
  { name: 'Оперативники',  winsToPromote: 5,    next: 'Корпораты' },
  { name: 'Корпораты',     winsToPromote: 7,    next: 'Высшая лига' },
  { name: 'Высшая лига',   winsToPromote: null, next: null }
];

const BY_NAME: Record<string, ClientLeague> = {};
LEAGUES_CLIENT.forEach(l => { BY_NAME[l.name] = l; });
BY_NAME['Высшая Лига'] = BY_NAME['Высшая лига']; // алиас регистра

export function getLeagueDef(name: string): ClientLeague {
  return BY_NAME[name] || LEAGUES_CLIENT[0];
}

// Сколько побед подряд нужно для подъёма ИЗ этой лиги. null = Высшая.
export function winsRequiredFromClient(leagueName: string): number | null {
  return getLeagueDef(leagueName).winsToPromote;
}

// Следующая лига (или null если Высшая).
export function nextLeagueClient(leagueName: string): string | null {
  return getLeagueDef(leagueName).next;
}
